import { type RefObject } from 'react';
import type { IChartApi } from 'lightweight-charts';
import { useChartPaneOverlayPosition } from '@/lib/chartPaneOverlay';
import { TradeVolumeStrip } from './TradeVolumeStrip';
import './TradeVolumeStrip.css';

const KLINE_PANE_INDEX = 1;

type Props = {
  chartRef: RefObject<IChartApi | null>;
  chartContainerRef: RefObject<HTMLDivElement | null>;
  exchange1: string;
  exchange2: string;
  exchange1InstId: string;
  exchange2InstId: string;
  enabled: boolean;
  klinePaneCollapsed: boolean;
  chartRevision?: number;
};

export function TradeVolumeChartOverlay({
  chartRef,
  chartContainerRef,
  exchange1,
  exchange2,
  exchange1InstId,
  exchange2InstId,
  enabled,
  klinePaneCollapsed,
  chartRevision = 0,
}: Props) {
  const top = useChartPaneOverlayPosition({
    chartRef,
    chartContainerRef,
    enabled,
    paneCollapsed: klinePaneCollapsed,
    paneIndex: KLINE_PANE_INDEX,
    chartRevision,
  });

  if (!enabled || klinePaneCollapsed || top == null) {
    return null;
  }

  return (
    <div
      className="realtime-spread-volume-chart-overlay"
      style={{ top: `${top}px` }}
      aria-hidden={false}
    >
      <TradeVolumeStrip
        exchange1={exchange1}
        exchange2={exchange2}
        exchange1InstId={exchange1InstId}
        exchange2InstId={exchange2InstId}
        variant="chart"
      />
    </div>
  );
}
